import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useManufacturer, Manufacturer } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<Manufacturer>
      useData={useManufacturer}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
